import { render, staticRenderFns } from "./shipment.vue?vue&type=template&id=3eedba50&scoped=true"
import script from "./shipment.vue?vue&type=script&lang=js"
export * from "./shipment.vue?vue&type=script&lang=js"
import style0 from "./shipment.vue?vue&type=style&index=0&id=3eedba50&prod&lang=scss&scoped=true"
import style1 from "./shipment.vue?vue&type=style&index=1&id=3eedba50&prod&lang=scss"
import style2 from "./shipment.vue?vue&type=style&index=2&id=3eedba50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eedba50",
  null
  
)

export default component.exports